import { createContext } from "react";
import { PuckPage } from "src/api/client-api/cms/useCreatePuckPage";

export type CMSContextInitialValues = {
    CMSPage: PuckPage | undefined;
    isContentFetched: boolean;
};

export const CMSContext = createContext<CMSContextInitialValues | null>(null);
